module.exports = __webpack_public_path__ + "static/media/MTL_ASC_GRD3.1916a26e.png";